import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex justify-between items-center p-4 bg-blue-500 text-white" }
const _hoisted_4 = { class: "flex items-center font-bold text-lg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-12 h-12 mr-2"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.$route.path.includes('/auth'))
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("main", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("Diary")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              class: "bg-green-500 px-2 py-1 rounded",
              to: "/manage-record"
            }, {
              default: _withCtx(() => [
                _createTextVNode("New")
              ]),
              _: 1
            }),
            _createElementVNode("a", {
              href: "#!",
              class: "ml-4",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, "Logout")
          ])
        ]),
        _createVNode(_component_router_view)
      ]))
}